<div style="display:flex; justify-content: space-between; column-gap: 80px;">
  <div>
    <h2 mat-dialog-title translate>COMMONS.PASSKEY_OTP_GENERATE_OK</h2>
  </div>
  <div>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
</div>
<div mat-dialog-content>
  <p>{{passKeyOkIntroduction}}</p>
  <div style=" width:100%; font-size: 2rem; display:flex;justify-content:center; margin-top: 1.5rem;margin-bottom: 1.5rem;">

    <div class="bgBluA100" style="padding:1.5rem;" > {{data.OTPToken}}</div>
    <div class="bgBluA100" style="padding:1.5rem;" ><mat-icon matTooltip="Copy OTP" matSuffix [inline]="true" class="pointer" (click)="copyOtp()">content_copy</mat-icon></div>
  </div>
  <p>{{passKeyOkDetails}}</p>
</div>

